import React from 'react';
import { PlaceHolderWrapper } from './PostCardPlaceHolder.style';
import { ExpandableBlockLoader } from '../../loader/BlockLoader.style';

export const PostCardPlaceHolder = () => (
  <PlaceHolderWrapper data-test="post-card-placeholder">
    <ExpandableBlockLoader />
    <div className="body">
      <ExpandableBlockLoader />
      <ExpandableBlockLoader />
      <ExpandableBlockLoader />
      <ExpandableBlockLoader />
    </div>
  </PlaceHolderWrapper>
);
